import "./FilmDevelopment.module.css";
import Header from "@/reusable_sections/Header";
import FilmServicesOverview from "./sections/FilmServicesOverview";
import ProcessSteps from "./sections/ProcessSteps";
import SuccessStories from "./sections/SuccessStories";
import Footer from "@/reusable_sections/Footer";
export default function FilmDevelopmentPage() {
  return <div>
      <Header />
      <FilmServicesOverview />
      <ProcessSteps />
      <SuccessStories />
      <Footer />
    </div>;
}